export enum FeatureToggle {
  GuestManagementEnhancements = 'rt_guest_management_enhancements',
  UserGrantAppeasements = 'rt_guest_management_appeasements',
  AppeasementEnableNewSection = 'rt_appeasement_enable_new_appeasement_section',
  // Inverted polarity: when enabled for a retailer, the Custom amount option is hidden in Grant Credits.
  AppeasementDisableCustomAmount = 'rt_appeasement_disable_custom_amount',
}
